/**
 * Terms and Conditions Content
 * Edit this file to update the terms displayed on the /terms page.
 * Each section has a title and content (supports multiple paragraphs).
 */

export const termsContent = {
  lastUpdated: 'January 2025',

  sections: [
    {
      title: 'Acceptance of Terms',
      content: [
        'By accessing or using Bandos, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.',
      ],
    },
    {
      title: 'Description of Service',
      content: [
        'Bandos is an AI-powered ideation and mind mapping platform designed to help you organize, develop, and visualize your ideas. We provide tools for brainstorming, project planning, and collaborative thinking.',
      ],
    },
    {
      title: 'User Accounts',
      content: [
        'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.',
        'You must provide accurate and complete information when creating an account and keep this information up to date.',
      ],
    },
    {
      title: 'Acceptable Use',
      content: [
        'You agree to use Bandos only for lawful purposes and in accordance with these Terms. You may not use our service to transmit harmful, offensive, or illegal content.',
        'You retain ownership of the content you create using Bandos. We do not claim any intellectual property rights over your ideas and projects.',
      ],
    },
    {
      title: 'AI-Generated Content',
      content: [
        'Bandos uses AI services (Anthropic Claude and OpenAI) to assist with idea generation and content suggestions. When you use AI features, minimal context from your current work is sent to these providers to generate relevant suggestions.',
        'AI-generated content is provided as a starting point and should be reviewed and refined by you. We do not guarantee the accuracy, completeness, or suitability of AI-generated suggestions for any particular purpose.',
        'Your projects are not used to train AI models. You are responsible for reviewing AI suggestions before using them in your work.',
      ],
    },
    {
      title: 'Third-Party Integrations',
      content: [
        'Bandos offers integrations with third-party services like Trello and Jira. When you connect these services, you authorize us to access and sync data between Bandos and those platforms.',
        "Your use of third-party integrations is also subject to those services' terms and privacy policies. You can disconnect integrations at any time from your settings.",
      ],
    },
    {
      title: 'Privacy & Data',
      content: [
        'Your privacy matters to us. We collect and process your data in accordance with our Privacy Policy. We use industry-standard security measures to protect your information.',
        'Your project data is stored securely and is not shared with third parties without your consent, except as required by law.',
        'For full details on how we collect, use, and protect your information, please read our Privacy Policy.',
      ],
      link: {
        text: 'Read our full Privacy Policy',
        href: '/privacy',
      },
    },
    {
      title: 'Service Availability',
      content: [
        'We strive to maintain high availability of our service but do not guarantee uninterrupted access. We may perform maintenance or updates that temporarily affect availability.',
        'We reserve the right to modify, suspend, or discontinue any part of the service with reasonable notice when possible.',
      ],
    },
    {
      title: 'Limitation of Liability',
      content: [
        'Bandos is provided "as is" without warranties of any kind. To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages arising from your use of the service.',
      ],
    },
    {
      title: 'Changes to Terms',
      content: [
        'We may update these Terms from time to time. We will notify you of significant changes by posting a notice on our platform or by email. Continued use of Bandos after changes constitutes acceptance of the updated Terms.',
      ],
    },
    {
      title: 'Contact',
      content: ['If you have questions about these Terms, please contact us at support@bandos.ai.'],
    },
  ],
}
